import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { useNoticeBannersStackContext, useResponsive } from '@sg/garnish';

import { NoResults as NoResultsDesktop } from './NoResults.desktop';

export const NoResults = ({ noAutocompleteResults = false }) => {
  const { formatMessage } = useIntl();
  const { currentBreakpoint } = useResponsive();

  const text = formatMessage(messages.locationNoResultsBanner);
  const message = noAutocompleteResults
    ? formatMessage(messages.locationNoAutocompleteResult)
    : formatMessage(messages.locationNoLocationsResult);

  const { push: addNoticeBanner } = useNoticeBannersStackContext();

  React.useEffect(() => {
    if (!currentBreakpoint.isXS) return;
    addNoticeBanner({ text, palette: 'neutral' });
  }, [text, currentBreakpoint.isXS, addNoticeBanner]);

  if (currentBreakpoint.isXS) return null;

  return <NoResultsDesktop message={message} />;
};

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  locationNoResultsBanner: {
    defaultMessage: `Oops, we couldn't find any sweetgreen locations. Try another search`,
    description: 'Location | No Results | Banner',
  },
  locationNoAutocompleteResult: {
    defaultMessage: `Ah snap peas! We couldn't find any locations.`,
    description: 'Location | No Autocomplete Result',
  },
  locationNoLocationsResult: {
    defaultMessage: `Ah snap peas! We couldn't find any sweetgreen locations.`,
    description: 'Location | No Locations Result',
  },
});
